import PostHero from './hero';
import PostShort from './short';
import PostVideo from './video';
import PostDefault from './default';
import ListArticle from './list';

export { PostHero, PostShort, PostVideo, PostDefault, ListArticle };
